import { render, staticRenderFns } from "./PagesHeroWidget.vue?vue&type=template&id=1bfb9f4a&"
import script from "./PagesHeroWidget.vue?vue&type=script&lang=js&"
export * from "./PagesHeroWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports